module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Medium-c7a7e292e6483ccdf0007ef03cb0846b.woff2";